import { Browser } from '@capacitor/browser';
import { getConfig } from '../../../config/environment';

const NONCE_KEY = 'native_implicit_nonce';

const { entraTenantSubdomain: tenantSubdomain, entraClientId: clientId, appId } = getConfig();
const redirectUri = `${appId ?? ''}://auth-redirect`;
const scopes = 'openid profile email';

function generateRandom(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
}

export async function launchNativeLogin(locale?: string): Promise<void> {
  const nonce = generateRandom();
  const state = generateRandom();
  localStorage.setItem(NONCE_KEY, nonce);

  const params = new URLSearchParams({
    client_id: clientId ?? '',
    response_type: 'id_token',
    redirect_uri: redirectUri,
    scope: scopes,
    response_mode: 'fragment',
    prompt: 'login',
    nonce,
    state,
    ...(locale ? { ui_locales: locale } : {}),
  });

  const url = `https://${tenantSubdomain}.ciamlogin.com/${tenantSubdomain}.onmicrosoft.com/oauth2/v2.0/authorize?${params.toString()}`;

  await Browser.open({ url });
}

export function extractIdToken(): string | null {
  const raw = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
  const params = new URLSearchParams(raw);
  const idToken = params.get('id_token');
  if (!idToken) return null;

  const storedNonce = localStorage.getItem(NONCE_KEY);
  if (storedNonce) {
    try {
      const base64 = idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(base64)) as { nonce?: string };
      if (payload.nonce !== storedNonce) return null;
    } catch {
      return null;
    }
    localStorage.removeItem(NONCE_KEY);
  }

  return idToken;
}
